import React from 'react';
import { Card } from '../../Card';
import Background from '../../Background';
import {
  TextContainer,
  Container,
  ContentContainer,
  Header,
  Text,
  CTA,
} from './Success.style';

const sentCopy = {
  supplier: `We've sent you an email which contains a link to verify your email address and set up a password to access your Ordermentum trial.`,
  retailer: `We've sent you an email which contains a link to verify your email address so you can create your retailer account.`,
};

// eslint-disable-next-line react/display-name
const SuccessPage = (copy: 'supplier' | 'retailer') => () => (
  <Background>
    <Card>
      <Container>
        <ContentContainer>
          <Header>Congratulations!</Header>
          <TextContainer>
            <Text>
              You&apos;re almost ready to go, please check your email.
            </Text>
            <Text>{sentCopy[copy]}</Text>
            <Text>
              If you haven&apos;t got the email, please check your spam folder.
              If you haven&apos;t received anything within 10 minutes please
              <CTA href="mailto:support@ordermentum.com"> contact us </CTA>
              and we&apos;ll help you out.
            </Text>
          </TextContainer>
        </ContentContainer>
      </Container>
    </Card>
  </Background>
);

export { SuccessPage };
